import "../date";

import { isNullOrWhitespace } from "./string";

/**
 * Adds the specified number of days to a new instance instance.The number can be positive or negative.
 */
export function addDays(value: Date, days: number) : Date {
    const clone = value.clone();
    clone.addDays(days);
    return clone;
}


/**
 * Adds the specified number of days to a new instance.The number can be positive or negative.
 */
export function addMonths(value: Date, months: number): Date {
    const clone = value.clone();
    clone.addMonths(months);
    return clone;
}


/**
 * Adds the specified number of years to a new instance.The number can be positive or negative.
 */
export function addYears(value: Date, years: number): Date {
    const clone = value.clone();
    clone.addYears(years);
    return clone;
}


/**
 * Resets the time of a new instance Date object to 12:00 AM(00:00), which is the start of the day.
 */
export function clearTime(value: Date): Date {
    const clone = value.clone();
    clone.clearTime();
    return clone;
}


/**
 * Determine if the value specified is a Date object
 * @param  {Any}  value
 *         The value to test.
 * @return {Boolean}
 *         Returns true if the value is a date otherwise false.
 */
export function isDate(value: any): boolean {
    return (value && value.getTime ? isFinite(value) : false);
}


/**
 * Moves the date to the first day of the month on a new date instance.
 */
export function moveToFirstDayOfMonth(value: Date): Date {
    const clone = value.clone();
    clone.moveToFirstDayOfMonth();
    return clone;
}


/**
 * Moves the date to the last day of the month on a new date instance.
 */
export function moveToLastDayOfMonth(value: Date): Date {
    const clone = value.clone();
    clone.moveToLastDayOfMonth();
    return clone;
}


/**
 * Sets the day of a new date instance relative to the beginning of the currently set month.
 */
export function setDate(value: Date, day: number): Date {
    const clone = value.clone();
    clone.setDate(day);
    return clone;
}


/**
 * Sets the month of a new date instance according to the currently set year.
 */
export function setMonth(value: Date, month: number): Date {
    const clone = value.clone();
    clone.setMonth(month);
    return clone;
}

/**
 * Formats the date according to the specified format.
 */
export function formatDate(value: Date, format: string): string {
    return isDate(value) ? value.toString(format) : "";
}

/**
 * Attempts to parse a value as a Date instance.
 * Uses DateJS parseExact method if a format string is specified,
 * otherwise uses DateJS parse method.
 * @param {string} value
 *     Value to parse.
 * @param {string = null} format
 *     Format string to use for DateJS parseExact method.
 * @param {string[] = null} extraParseFormats
 *     Array of format strings to pass to DateJS parseExact method.
 * @returns {Date}
 *     Parsed Date instance, null if empty value provided, or undefined if value was unparseable.
 */
export function parseDate(value: string, format: string = "", extraParseFormats: string[] = null): Date {
    // ignore white-space or empty
    if (value === undefined || value === null || (typeof value === "string" && isNullOrWhitespace(value))) {
        return null;
    }
    // DateJS dies on non-string/Date input
    if (typeof value !== "string") {
        throw new Error("parseDate expects a string for 'value'");
    }

    // parseExact guarantees the value is correctly parsed using custom/default format
    // (especially important for ambigious date formats such as MM/dd/yyyy & dd/MM/yyyy)
    // the parse fallback supports values such as (today, tomorrow, next week, next thursday, June 15 1997, ...)

    let d = Date.parseExact(value, format);
    if (extraParseFormats && !d) {
        d = Date.parseExact(value, extraParseFormats);
    }
    if (!d) {
        d = Date.parse(value);
    }

    return (isDate(d) ? d : undefined);
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/util/date.ts